import { getCookie } from 'cookies-next'

// linkedin cookie get
export function getLinkedIn() {
  return (
    (typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('li_fat_id')) ||
    getCookie('li_fat_id') ||
    null
  )
}
